import React from "react";
import { Link } from "react-router-dom";
import logoUBoussole from "@/images/logoUboussole.svg";

class Header extends React.Component {
  render() { 
    let element = 
      <header className=" bg-gray-darkest py-9 w-full text-white relative z-10">
          <Link to="/">
            <div className="absolute top-0 flex justify-center w-full">
                <div className="absolute bg-gray-darkest rounded-bottom-10 flex flex-col items-center">
                  <img src={logoUBoussole} alt="logo boussole" className="w-9 mt-3"/>
                  <h1 className="md:pb-10 pb-8 px-12 md:text-4xl text-2xl leading-6 font-mixBold">
                    <span className="text-orange">u</span>Boussole
                  </h1>
                </div>
            </div>
          </Link>
      </header>;
    return element;
  }
}
 
export default Header;